// https://www.finanssiala.fi/wp-content/uploads/2023/04/suomalaiset-rahalaitostunnukset-ja-bic-21042023.pdf
var FINNISH_BIC_CODES = {
  6: 'AABAFI22',
  717: 'BIGKFIHI',
  713: 'CITIFIHX',
  714: 'EVSEFIHH',
  8: 'DABAFIHH',
  34: 'DABAFIHH',
  37: 'DNBAFIHX',
  33: 'ESSEFIHX',
  31: 'HANDFIHH',
  405: 'HELSFIHH',
  497: 'HELSFIHH',
  799: 'HOLVFIHH',
  400: 'ITELFIHH',
  402: 'ITELFIHH',
  403: 'ITELFIHH',
  406: 'ITELFIHH',
  407: 'ITELFIHH',
  408: 'ITELFIHH',
  410: 'ITELFIHH',
  411: 'ITELFIHH',
  412: 'ITELFIHH',
  414: 'ITELFIHH',
  415: 'ITELFIHH',
  416: 'ITELFIHH',
  417: 'ITELFIHH',
  418: 'ITELFIHH',
  419: 'ITELFIHH',
  420: 'ITELFIHH',
  421: 'ITELFIHH',
  423: 'ITELFIHH',
  424: 'ITELFIHH',
  425: 'ITELFIHH',
  426: 'ITELFIHH',
  427: 'ITELFIHH',
  428: 'ITELFIHH',
  429: 'ITELFIHH',
  430: 'ITELFIHH',
  431: 'ITELFIHH',
  432: 'ITELFIHH',
  435: 'ITELFIHH',
  436: 'ITELFIHH',
  437: 'ITELFIHH',
  438: 'ITELFIHH',
  439: 'ITELFIHH',
  440: 'ITELFIHH',
  441: 'ITELFIHH',
  442: 'ITELFIHH',
  443: 'ITELFIHH',
  444: 'ITELFIHH',
  445: 'ITELFIHH',
  446: 'ITELFIHH',
  447: 'ITELFIHH',
  448: 'ITELFIHH',
  449: 'ITELFIHH',
  450: 'ITELFIHH',
  451: 'ITELFIHH',
  452: 'ITELFIHH',
  454: 'ITELFIHH',
  455: 'ITELFIHH',
  456: 'ITELFIHH',
  457: 'ITELFIHH',
  458: 'ITELFIHH',
  459: 'ITELFIHH',
  460: 'ITELFIHH',
  461: 'ITELFIHH',
  462: 'ITELFIHH',
  463: 'ITELFIHH',
  464: 'ITELFIHH',
  483: 'ITELFIHH',
  484: 'ITELFIHH',
  485: 'ITELFIHH',
  486: 'ITELFIHH',
  487: 'ITELFIHH',
  488: 'ITELFIHH',
  489: 'ITELFIHH',
  490: 'ITELFIHH',
  491: 'ITELFIHH',
  492: 'ITELFIHH',
  493: 'ITELFIHH',
  495: 'ITELFIHH',
  496: 'ITELFIHH',
  715: 'ITELFIHH',
  1: 'NDEAFIHH',
  2: 'NDEAFIHH',
  5: 'OKOYFIHH',
  470: 'POPFFI22',
  471: 'POPFFI22',
  472: 'POPFFI22',
  473: 'POPFFI22',
  474: 'POPFFI22',
  475: 'POPFFI22',
  476: 'POPFFI22',
  477: 'POPFFI22',
  478: 'POPFFI22',
  479: 'POPFFI22',
  36: 'SBANFIHH',
  39: 'SBANFIHH',
  38: 'SWEDFIHH',
  796: 'NARYFIH2',
  798: 'VPAYFIH2'
};
export default FINNISH_BIC_CODES;